export default __webpack_public_path__ + "static/aggielee2-2ceefb3f8008708c47849f202ef70977.jpg";